import { render } from "./TariffTabs.vue?vue&type=template&id=06ac898a&scoped=true"
import script from "./TariffTabs.vue?vue&type=script&lang=js"
export * from "./TariffTabs.vue?vue&type=script&lang=js"

import "./TariffTabs.vue?vue&type=style&index=0&id=06ac898a&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ac898a"]])

export default __exports__